module.exports = __webpack_public_path__ + "static/leopard1-6ab4cc0509f76bca4a2244cd6dd82597.png";